var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcomeBox"},[_c('div',{staticClass:"inWelcome"},[_c('img',{staticClass:"welcomeImg",attrs:{"src":"http://www.hfmphe.net/welcome5.png"}}),_c('div',{staticClass:"TextBox"},[_c('div',{staticClass:"welcome"},[_vm._v("WELCOME")]),_c('div',{staticClass:"sys_name"},[_vm._v("欢迎使用霍夫曼后台管理系统")])])])])
}]

export { render, staticRenderFns }